import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import { useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Branches from "./pages/Branches";
import Users from "./pages/Users";
import Products from "./pages/Products";
import Reports from "./pages/Reports";
import Billing from "./pages/Billing";
import PrintInvoice from "./pages/PrintInvoice";
import Settings from "./pages/Settings";
import Inventory from "./pages/Inventory";
import InvoiceHistory from "./pages/InvoiceHistory";
import InvoiceView from "./pages/InvoiceView";
import { useNetworkSync } from "./hooks/useNetworkSync";
import ReloadWarningPopup from "./components/ReloadWarningPopup";



function App() {
  const { user, loading } = useAuth();

// useEffect(() => {
    useNetworkSync();
  // }, []);


if (loading) return <div>Loading...</div>;

  return (
    <>
    <ReloadWarningPopup/>
    <BrowserRouter>

      <Routes>

<Route path="/print/:invoiceId" element={<PrintInvoice />} />
<Route path="/print/offline/:invoiceId" element={<PrintInvoice />} />
        {/* PUBLIC ROUTES */}
        <Route path="/login" element={<Login />} />

        {/* PRINT (NO LAYOUT) */}
        <Route path="/print/:invoiceId" element={<PrintInvoice />} />
        <Route path="/invoice/:id" element={<InvoiceView />} />

        {/* PROTECTED APP */}
        <Route
          path="/"
          element={
            user ? <Layout /> : <Navigate to="/login" />
          }
        >
          <Route
            index
            element={
              <ProtectedRoute roles={["SUPER_ADMIN", "ADMIN", "MANAGER"]}>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="branches"
            element={
              <ProtectedRoute roles={["SUPER_ADMIN", "ADMIN"]}>
                <Branches />
              </ProtectedRoute>
            }
          />

          <Route
            path="users"
            element={
              <ProtectedRoute roles={["SUPER_ADMIN", "ADMIN"]}>
                <Users />
              </ProtectedRoute>
            }
          />

          <Route
            path="products"
            element={
              <ProtectedRoute roles={["SUPER_ADMIN", "ADMIN", "CASHIER"]}>
                <Products />
              </ProtectedRoute>
            }
          />

          <Route
            path="inventory"
            element={
              <ProtectedRoute roles={["SUPER_ADMIN", "ADMIN", "MANAGER", "CASHIER"]}>
                <Inventory />
              </ProtectedRoute>
            }
          />

          <Route
            path="reports"
            element={
              <ProtectedRoute roles={["SUPER_ADMIN", "ADMIN", "MANAGER"]}>
                <Reports />
              </ProtectedRoute>
            }
          />

          <Route
            path="billing"
            element={
              <ProtectedRoute roles={["CASHIER"]}>
                <Billing />
              </ProtectedRoute>
            }
          />

          <Route
            path="invoices"
            element={
              <ProtectedRoute roles={["SUPER_ADMIN", "ADMIN", "MANAGER", "CASHIER"]}>
                <InvoiceHistory />
              </ProtectedRoute>
            }
          />

          <Route
            path="settings"
            element={
              <ProtectedRoute roles={["SUPER_ADMIN"]}>
                <Settings />
              </ProtectedRoute>
            }
          />
        </Route>

      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
